import type { PropsWithChildren, Ref } from "react";
import {
  KeyboardAvoidingView,
  Platform,
  ScrollView,
  StyleSheet,
  type KeyboardAvoidingViewProps,
  type ViewStyle,
} from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";

import { spacing, surface } from "@/src/theme/tokens";

type Props = PropsWithChildren<{
  contentStyle?: ViewStyle;
  keyboardBehavior?: KeyboardAvoidingViewProps["behavior"];
  scrollViewRef?: Ref<ScrollView>;
}>;

export function ScreenContainer({
  children,
  contentStyle,
  keyboardBehavior = Platform.OS === "ios" ? "padding" : undefined,
  scrollViewRef,
}: Props) {
  return (
    <SafeAreaView style={styles.safeArea}>
      <KeyboardAvoidingView behavior={keyboardBehavior} style={styles.keyboard}>
        <ScrollView ref={scrollViewRef} contentContainerStyle={[styles.content, contentStyle]} keyboardShouldPersistTaps="handled">
          {children}
        </ScrollView>
      </KeyboardAvoidingView>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  safeArea: { backgroundColor: surface.secondary, flex: 1 },
  keyboard: { flex: 1 },
  content: { flexGrow: 1, paddingHorizontal: spacing.xl, paddingVertical: spacing.xxl },
});
